export const MOCKED_URL_TAXONOMY = 'https://www.samsung.com.br/cadastro-bespoke/?cid=br_PAID_SOCIAL_META_DISHWASHER_WARM_DW_IMAGE_DISHWASHER:LANCAMENTO-CAR-VERT-1080X1920-24022023_BLINKS-WSC-MICRO:CAMPANHAS-TG-SOCIAL:ALWAYSON-ST-OCPM-BR-A-DKMO-ANDIOS-DKP-NA-SSG-INSTAGRAM-AON2023-AON2023INSTAGRAMSRC-NA'
// export const MOCKED_URL_TAXONOMY = 'https://www.samsung.com/br/'

export const urlTaxonomiesValidation = (urlTaxnomy) => {
  const filterSocial = urlTaxnomy.match(/(facebook|instagram|twitter|youtube|linkedin|pinterest|tiktok|twitch|reddit|snapchat|tumblr|whatsapp|telegram|discord|tiktok|twitch|reddit|snapchat|tumblr|whatsapp|telegram|discord)/gi)
  if(typeof  filterSocial !== "undefined" && filterSocial !== null && filterSocial[0] !== "undefined") {
    // const source = filterSocial[0].charAt(0).toUpperCase() + filterSocial[0].slice(1)
    const getAfterSocial = urlTaxnomy.split(filterSocial[0])
    const filterJustName = getAfterSocial[1].slice(1).split('_')[0]
    const checkIfTheresEmail = filterJustName.match(/(email)/gi);
    if(filterSocial) {
      return {
        custom01: filterSocial[0],
        custom02: "SOCIAL",
      }
    }
    return {
      custom01: filterJustName,
      custom02: checkIfTheresEmail,
      custom03: filterSocial,
    }
  }
  const checkIfIsOrganic = urlTaxnomy.match(/(ORGANIC)/gi);
  if(checkIfIsOrganic) {
    const getAfterOrganic = urlTaxnomy.split(checkIfIsOrganic[0])
    const getMedium = getAfterOrganic[1].split('&')[1].split('=')[1]
    return {
      custom01: getMedium,
      custom02: checkIfIsOrganic[0]
    }
  }
  const checkIfTheresEmail = urlTaxnomy.match(/(email)/gi);
  if(checkIfTheresEmail) {
    const getAfterEmail = urlTaxnomy.split(checkIfTheresEmail[0])
    const getEmail = getAfterEmail[1].slice(1).split('&')[0]
    return {
      custom01: "email",
      custom02: getEmail,
    }
  }

  return "Microsites"
}